<div class="navigation-dropdown" (mouseleave)="setIsOpen(false)">
  <div
    class="chevron"
    [ngClass]="{ 'menu-toggle': true, active: isActive() }"
    (mouseover)="setIsOpen(true)"
    (focus)="setIsOpen(true)"
    (focusout)="onBlur($event)"
    (keypress)="handleArrowPress($event)"
    tabindex="1">
    <p class="menu-link">
      {{ navigationItem.title | translate }}
    </p>
  </div>
  <div
    class="menu"
    (mouseover)="setIsOpen(true)"
    (focus)="setIsOpen(true)"
    (focusout)="onBlur($event)"
    (focusin)="setIsOpen(true)"
    tabindex="1">
    @for (link of navigationItem.children; track link.title) {
      @if (link.hasClaims) {
        <a class="child-link" (click)="navigate(link.url)">{{ link.title | translate }}</a>
      }
    }
  </div>
</div>
